<div class="flex h-fit w-full flex-col">
  <div class="flex h-full flex-col gap-2.5 rounded-3xl bg-gray-100 p-8">
    <span class="text-2xl">{{ title }}</span>
    <span class="text-lg text-tertiary-foreground">{{ subtitle }}</span>
  </div>
  <div class="flex h-full w-full flex-col items-start gap-8 rounded-3xl bg-gray-100">
    <form
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit()"
      class="grid h-full w-full grid-cols-2 items-start gap-6 rounded-3xl bg-gray-100 p-8">

      @for (field of fields; track field.name) {

        @if (field.type === 'text' || field.type === 'email' || field.type === 'phone') {
          <div [class]="field.fullWidth ? 'col-span-2' : 'col-span-2 md:col-span-1'">
            <app-input
              [control]="field.name"
              [placeholder]="field.placeholder || 'Type...'"
              [label]="field.label"
              [inputMode]="field.onlyNumbers ? 'numeric' : 'text'"
              (keydown)="field.onlyNumbers ? onKeyDown($event) : null"/>
          </div>
        }

        @if (field.type === 'select') {
          <div [class]="field.fullWidth ? 'col-span-2' : 'col-span-2 md:col-span-1'">
            <app-spartan-select
              [control]="field.name"
              [placeholder]="field?.placeholder ?? 'Select'"
              [options]="field.options ?? []"
              [label]="field.label"/>
          </div>
        }

        @if (field.type === 'textarea') {
          <div [class]="field.fullWidth ? 'col-span-2' : 'col-span-2 md:col-span-1'">
            <app-textarea
              [control]="field.name"
              [placeholder]="field?.placeholder ?? 'Type...'"
              [showWordCounter]="true"
              [label]="field.label"/>
          </div>
        }

        @if (field.type === 'file') {
          <label class="col-span-2 flex w-full flex-col gap-1 text-sm font-medium"
                 [class]="field.fullWidth ? 'col-span-2' : 'md:col-span-1'">
            <div class="flex gap-1">
              <span>{{ field.label }}</span>
              @if (formGroup.get(field.name)!.hasValidator(Validators.required)) {
                <span class="text-primary"> * </span>
              }
            </div>
            <app-file-upload [control]="field.name" [maxSizeMB]="1" [multiple]="multipleDocs"/>
          </label>
        }
      }

      <label class="col-span-2 flex flex-col gap-2 text-sm" hlmLabel>
        <div class="flex items-center gap-0.5">
          <hlm-checkbox class="mr-2 rounded-lg border border-primary p-[1px]" [formControlName]="'agree'"/>
          <div class="flex flex-wrap gap-1.5">
            <span>You agree to our friendly</span>
            <span class="cursor-pointer underline hover:text-primary">privacy policy</span>
          </div>
        </div>
        @if (formGroup.get('agree')?.touched && formGroup.get('agree')?.invalid) {
          <span class="col-span-2 mt-1 text-xs text-destructive">You must accept the privacy policy.</span>
        }
      </label>

      <button hlmBtn type="submit" class="col-span-2 flex h-11 w-full gap-3 rounded-xl text-base" [disabled]="loading">
        @if (loading) {
          <hlm-spinner/>
        }
        <span>Submit</span>
      </button>
    </form>
  </div>
</div>
